import type { AppearancePreviewMessage } from "@/src/types/appearancePreview.types";

// Enveloppe des messages éditeur ↔ storefront : documentation/appearance-preview-contract.md (§5).

export const APPEARANCE_PREVIEW_CHANNEL = "okast-appearance-preview" as const;
export const APPEARANCE_PREVIEW_VERSION = 1 as const;

export function createPreviewMessage<Type extends string, Payload>(
  type: Type,
  payload: Payload,
): AppearancePreviewMessage<Type, Payload> {
  return {
    channel: APPEARANCE_PREVIEW_CHANNEL,
    version: APPEARANCE_PREVIEW_VERSION,
    type,
    payload,
  };
}

export function isPreviewMessage(data: unknown, type: string): boolean {
  if (typeof data !== "object" || data === null) return false;

  return (
    "channel" in data &&
    data.channel === APPEARANCE_PREVIEW_CHANNEL &&
    "version" in data &&
    data.version === APPEARANCE_PREVIEW_VERSION &&
    "type" in data &&
    data.type === type
  );
}

export const APPEARANCE_PREVIEW_URL_PARAM = "appearance_preview";

export function buildPreviewUrl(baseUrl: string): string {
  const url = new URL(baseUrl);
  url.searchParams.set(APPEARANCE_PREVIEW_URL_PARAM, "1");

  return url.toString();
}
